<template>
  <img :src="propsStore.logo" class="relative -top-12 mx-auto" width="400px" />
  <div class="flex flex-row justify-center align-middle">
    <Card
      class="p-4 sm:basis-full md:basis-2/3 xl:basis-1/2 2xl:basis-1/3 rounded-xl"
      pt:root:class="bg-white/80! backdrop-blur-xl dark:bg-surface-800/90! border-surface-200! dark:border-surface-600! border!"
      :pt-options="{ mergeProps: false }"
    >
      <template #title>
        <div class="relative text-center -inset-y-12 -m-5">
          <span class="bg-primary-500 dark:bg-primary-400 inline-flex justify-center items-center rounded-full drop-shadow-xl p-4">
            <i class="pi pi-lock text-4xl text-white dark:text-surface-800"></i>
          </span>
        </div>
        <p class="text-center text-sm font-normal">Please provide your username for password reset.</p>
      </template>
      <template #content>
        <IconField iconPosition="left" class="mb-6 text-2xl w-full">
          <InputIcon>
            <i class="pi pi-user relative -top-1"></i>
          </InputIcon>
          <InputText placeholder="Username" v-model="userVal" type="text" class="w-full" v-on:keyup.enter="sendReset" />
        </IconField>
        <Button label="Reset Password" class="w-full text-2xl" raised @click="sendReset"></Button>
        <Button label="Cancel" class="w-full text-2xl" text raised @click="$emit('navigate', 'LOGIN')"></Button>
        <div class="text-center pt-5 -mb-5">
          <Button label="Forgot Username" class="px-10 text-lg" text @click="$emit('navigate', 'USERNAME')"></Button>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { usePropsStore } from "@/stores/props";

const userVal = ref("");
const authStore = useAuthStore();

const propsStore = usePropsStore();

const emit = defineEmits<{
  navigate: [to: "LOGIN" | "PASSWORD" | "USERNAME"];
}>();

interface Props {
  adminLogin: boolean;
}
const props = defineProps<Props>();

const sendReset = (): void => {
  const data = new FormData();
  data.append("username", userVal.value);
  const forgotPassString = props.adminLogin ? "/admin/forgotpass" : "/portal/forgotpass";
  authStore.sessionExpired = false;
  axios
    .post(forgotPassString, data)
    .then((response) => {
      success("Email Sent", "An email was sent if the username is valid");
      emit("navigate", "LOGIN");
    })
    .catch((e) => errorApi(e));
};
</script>
